import formatString from '../services/stringService';

enum EntityEnum {
  Invoice = 'invoice',
  Estimate = 'estimate',
}

const toEntityEnum = (entity: string | EntityEnum): EntityEnum | undefined => {
  const value = entity.toLowerCase();
  return (Object.values(EntityEnum) as string[]).includes(value)
    ? (value as EntityEnum)
    : undefined;
};

const entityEnumRoutes = {
  [EntityEnum.Invoice]: 'invoices/{0}/edit',
  [EntityEnum.Estimate]: 'estimates/{0}/edit',
};

const entityEnumNames = {
  [EntityEnum.Invoice]: 'Ordem de Serviço',
  [EntityEnum.Estimate]: 'Orçamento',
};

export const getEntityRoute = (
  entity: string | EntityEnum,
  ...args: (string | number)[]
) => {
  const value = toEntityEnum(entity);
  return !value ? '/' : formatString(entityEnumRoutes[value], ...args);
};

export const getEntityName = (entity: string | EntityEnum) => {
  const value = toEntityEnum(entity);
  return !value ? entity : entityEnumNames[value];
};
